import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import PieChartComponent from '../../../../library/SimpleControls/PieChartControl';
import useRecruiterDashboard from './useRecruiterDashboard';

const RecruiterLocation = () => {
    const { state } = useContext(SmartContext);
    const { getRecruiterLocation } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterLocation();
    }, [state.data.searchCriteria.recruiterLocation]);

    if (isEmpty(state.data?.reportData?.recruiterLocation))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <PieChartComponent data={state.data.reportData.recruiterLocation} />
        </>
    );
};

export default RecruiterLocation;
